export default "__VITE_ASSET__p9UA4jQV__"